module.exports = __webpack_public_path__ + "media/images/logos/ncce-logo-with-bg-782e7d59db7c3b16da0d48e55833650b.svg";